module.exports = {
    props: {
        /**
         * @prop active
         * @type {Boolean}
         * @default false
         * @description indicate the nav-item is active or not
         */
        active: {
            type: Boolean,
            default: false
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui-vue/mixins/NavItemPropMixin.js
 ** module id = 56
 ** module chunks = 0
 **/